import '../App.css';
import { Link } from 'react-router-dom';
import siteLogo from '../images/site-logo.png';
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../store/auth/authActions";
import { useNavigate } from 'react-router-dom';
import NotificationBell from './NotificationBell';

function SignupHeader() {
    const dispatch = useDispatch();
  const navigate = useNavigate();

const { isAuthenticated, user } = useSelector((state) => state.auth);
    /* if (!isAuthenticated) {
    return <Navigate to="/omnipod-creator-login" />;
    } */
  const logoutHandler = () => {
    dispatch(logout());
    navigate("/omnipod-creator-login"); 
  };
  return (
    <>
      <div className="hero__logo">
        <Link to="/">
            <img src={siteLogo} alt="Omnipod Creator Marketplace logo" className="insulet-header__logo" />
          </Link>
      </div>

      <div className="hero__actions">
        
         {!isAuthenticated && (
          <Link className="action-btn" to="/omnipod-creator-login">
          Log In
        </Link>
      )}
       {isAuthenticated && (
        <>
        <nav className="insulet-header__nav">
          <span className="user-name">
              <Link className="insulet-header__link" to="/dashboard">
                {user?.name || "User"}
              </Link>
            </span>
          {/* <a className="insulet-header__link" href="#creators">{user?.name || "User"}</a> */}
          </nav>
          <div className="header-right">
            <NotificationBell />
            <button onClick={logoutHandler} className="action-btn action-btn--primary" >
              Logout
            </button>
          </div>
          </>
        )}
      {/*   <button className="action-btn action-btn--primary">Get Started</button> */}
      </div>
    </>
  );
}

export default SignupHeader;
